import { render, staticRenderFns } from "./HyShopRouter.vue?vue&type=template&id=162dcc92&scoped=true"
import script from "./HyShopRouter.vue?vue&type=script&lang=js"
export * from "./HyShopRouter.vue?vue&type=script&lang=js"
import style0 from "./HyShopRouter.vue?vue&type=style&index=0&id=162dcc92&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162dcc92",
  null
  
)

export default component.exports